import { radianToDegree } from '@/utilities/vector';
import { useChartDefinitionsContext } from '@/components/ChartDefinitionsContext';

interface PinProps {
  angle: number;
  fill: string;
}

const LargePin = ({ angle, fill }: PinProps) => {
  const { largePin } = useChartDefinitionsContext();
  return (
    <g
      transform={`translate(-6,-104.5) rotate(${radianToDegree(
        angle
      )}, 6, 104.5)`}
    >
      <use xlinkHref={`#${largePin}`} fill={fill} />
    </g>
  );
};

const MediumPin = ({ angle, fill }: PinProps) => {
  const { mediumPin } = useChartDefinitionsContext();
  return (
    <g
      transform={`translate(-5,-86.5) rotate(${radianToDegree(
        angle
      )}, 5, 86.5)`}
    >
      <use xlinkHref={`#${mediumPin}`} fill={fill} />
    </g>
  );
};

const SmallPin = ({ angle, fill }: PinProps) => {
  const { smallPin } = useChartDefinitionsContext();
  return (
    <g
      transform={`translate(-4,-68.5) rotate(${radianToDegree(
        angle
      )}, 4, 68.5)`}
    >
      <use xlinkHref={`#${smallPin}`} fill={fill} />
    </g>
  );
};

export type PinSize = 'small' | 'medium' | 'large';

export interface Props {
  size: PinSize;
  angle: number;
  fill: string;
}

const Pin = ({ size, angle, fill }: Props) => {
  switch (size) {
    case 'small':
      return <SmallPin angle={angle} fill={fill} />;
    case 'medium':
      return <MediumPin angle={angle} fill={fill} />;
    case 'large':
      return <LargePin angle={angle} fill={fill} />;
    default:
      return null;
  }
};

export default Pin;
